import ManageMedia from '~/api/manage_media';
import { Message } from 'element-ui';

export default {
    postIn5Template({state, commit}) {
        commit('updateIsSaving', true);

        ManageMedia.postIn5Template(state.formData).then(response => {
            Message({
                duration: 1000,
                type: 'success',
                message: response.msg,
                onClose() {
                    window.location.href = `${window.location.origin}/manage-media/form/${response.media_id}`;
                }
            });

            commit('updateUploadDialogOpen', false);
            commit('updateIsSaving', false);
        }).catch((xhr) => {
            commit('updateValidations', xhr.validations);
            commit('updateIsSaving', false);
        });
    }
}